export default __webpack_public_path__ + "static/media/bottomDecorations.86d9f029.png";